import script from "./QuickTagFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickTagFilters.vue?vue&type=script&setup=true&lang=js"

import "./QuickTagFilters.vue?vue&type=style&index=0&id=14967d87&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14967d87"]])

export default __exports__